import _extends from "@babel/runtime/helpers/extends";
import appConfig from '@jobmatchme/library-utils/es/appConfig';
import { v4 as uuid } from 'uuid';
var SIGNUP_ROUTER_ASSIGNMENT_KEY = 'jobmatch:signup-router-assignment:v2';
var SIGNUP_ROUTER_COOKIE_PREFIX = 'jobmatch_signup_router_assignment';
var SIGNUP_ROUTER_ASSIGNMENT_MAX_AGE_MS = 60 * 60 * 1000;
var SIGNUP_FUNNEL_STEP_CONTRACT_VERSION = 1;
var signupRouterCookieNamespace = function signupRouterCookieNamespace(hostname) {
  var normalizedHostname = (hostname || '').toLowerCase();
  var stageMatch = normalizedHostname.match(/^(?:www-)?(nm|ta|tp|tz)\.jobmatch\.me$/);
  var environment = stageMatch ? stageMatch[1] : ['app.jobmatch.me', 'www.jobmatch.me', 'jobmatch.me'].includes(normalizedHostname) ? 'prod' : normalizedHostname.replace(/[^a-z0-9]+/g, '_');
  return "".concat(SIGNUP_ROUTER_COOKIE_PREFIX, "_").concat(environment, "_");
};
var signupRouterAssignmentValues = function signupRouterAssignmentValues() {
  var cookieNamespace = signupRouterCookieNamespace(window.location.hostname);
  var values = document.cookie.split(';').map(function (entry) {
    return entry.trim();
  }).filter(function (entry) {
    return entry.startsWith(cookieNamespace);
  }).map(function (entry) {
    try {
      return decodeURIComponent(entry.slice(entry.indexOf('=') + 1));
    } catch (_unused) {
      return null;
    }
  }).filter(function (value) {
    return value !== null;
  });
  try {
    var sessionValue = sessionStorage.getItem(SIGNUP_ROUTER_ASSIGNMENT_KEY);
    if (sessionValue) values.push(sessionValue);
  } catch (_unused2) {
    // A shared first-party cookie is sufficient when tab storage is unavailable.
  }
  return values;
};
export var currentLegacySignupAssignment = function currentLegacySignupAssignment() {
  try {
    return signupRouterAssignmentValues().map(function (value) {
      try {
        return JSON.parse(value);
      } catch (_unused3) {
        return null;
      }
    }).filter(function (assignment) {
      if (!assignment) return false;
      var assignedAt = Date.parse(assignment.assignedAt);
      return assignment.version === 2 && assignment.allocationVersion === 2 && assignment.destinationApp === 'old_jobs' && Boolean(assignment.routerDecisionId) && Number.isFinite(assignedAt) && assignedAt <= Date.now() && Date.now() - assignedAt < SIGNUP_ROUTER_ASSIGNMENT_MAX_AGE_MS;
    }).sort(function (left, right) {
      return Date.parse(right.assignedAt) - Date.parse(left.assignedAt);
    })[0] || null;
  } catch (_unused4) {
    return null;
  }
};

/** Adds the old-jobs assignment through the generic registration context. */
export var withLegacySignupRegistrationContext = function withLegacySignupRegistrationContext(request) {
  var assignment = currentLegacySignupAssignment();
  if (!assignment) return request;
  return _extends(request, {
    registrationContext: {
      correlations: {
        'matching.signup_assignment': assignment.routerDecisionId
      }
    }
  });
};
export var legacySignupSemanticStep = function legacySignupSemanticStep(step) {
  var normalized = step.toLowerCase();
  if (/email|phone|name|account|password|registration/.test(normalized)) {
    return 'account';
  }
  if (/job|profession|place|location|employment|worktype/.test(normalized)) {
    return 'jobsearch';
  }
  return 'profile';
};

/**
 * Links one data-minimized legacy funnel observation to the router decision
 * that selected the old registration app.
 */
export var trackLegacySignupFunnelStep = function trackLegacySignupFunnelStep(_ref) {
  var appStepId = _ref.appStepId,
    semanticStep = _ref.semanticStep,
    status = _ref.status;
  var assignment = currentLegacySignupAssignment();
  if (!assignment) return;
  fetch("".concat(appConfig.routes.comApi, "/tracking/signup-funnel/steps"), {
    method: 'POST',
    credentials: 'include',
    keepalive: true,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      clientEventId: uuid(),
      routerDecisionId: assignment.routerDecisionId,
      registrationApp: 'old_jobs',
      funnelContractVersion: SIGNUP_FUNNEL_STEP_CONTRACT_VERSION,
      appVersion: 'jobmatchme-legacy',
      semanticStep: semanticStep,
      appStepId: String(appStepId || 'unknown').slice(0, 128),
      status: status,
      clientEventAt: new Date().toISOString()
    })
  }).catch(function (error) {
    return console.warn('Signup funnel step tracking failed.', error);
  });
};